import React from "react";
import { AddIconColor, RedDeleteIcon } from "../../../assets/images";
import "./style.scss";
import AddParentChildBtn from "./AddParentChildBtn";
import {
  FirstLevelType,
  ProceduresType,
  ProcedureType,
  SecondLevelType,
  SubHeadingType,
} from "../../../commonTypes/jobsType";

type AppProps = {
  history?: any;
  data: ProceduresType;
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  setData: React.Dispatch<React.SetStateAction<ProceduresType>>;
  type: string;
  handleSubmit: () => void;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddMoreInput = ({
  history,
  data,
  title,
  setTitle,
  setData,
  type,
  handleSubmit,
  setModal,
}: AppProps) => {
  const job_type_id =
    history &&
    history?.location &&
    history?.location?.state &&
    history?.location?.state?.job_id;
  const searchTerm = history?.location?.state?.searchTerm;

  const handleGoBack = () => {
    history?.push({
      pathname: `/jobs/jobs-type/checklist`,
      state: { job_id: job_type_id, searchTerm: searchTerm?.trim() },
    });
  };
  const handleAddProcedure = () => {
    let newData = JSON.parse(JSON.stringify(data));
    newData.push({ key: "procedure", value: "", subHeading: [] });
    setData([...newData]);
  };

  const handleAddSubHeading = (index: number) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index]?.subHeading?.push({ key: "sub", value: "", firstLevel: [] });
    setData([...newData]);
  };

  const handleAddFirstLevel = (index: number, subIndex: number) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index]?.subHeading[subIndex]?.firstLevel?.push({
      key: "firstLevel",
      value: "",
      secondLevel: [],
    });
    setData([...newData]);
  };

  const handleAddSecondLevel = (
    index: number,
    subIndex: number,
    firstIndex: number
  ) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index]?.subHeading[subIndex]?.firstLevel[
      firstIndex
    ]?.secondLevel?.push({
      key: "secondLevel",
      value: "",
      thirdLevel: [],
    });
    setData([...newData]);
  };

  const handleChange = (e: any, key: number) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[key] = {
      ...newData[key],
      key: "procedure",
      value: e?.target?.value,
      subHeading: newData[key]?.subHeading ? newData[key]?.subHeading : [],
    };
    setData([...newData]);
  };

  const handleSubChange = (e: any, index: number, subIndex: number) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index].subHeading[subIndex] = {
      ...newData[index]?.subHeading[subIndex],
      key: "sub",
      value: e?.target?.value,
      firstLevel: newData[index]?.subHeading[subIndex]?.firstLevel
        ? newData[index]?.subHeading[subIndex]?.firstLevel
        : [],
    };
    setData([...newData]);
  };

  const handleFirstLevelChange = (
    e: any,
    index: number,
    subIndex: number,
    firstIndex: number
  ) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index].subHeading[subIndex].firstLevel[firstIndex] = {
      ...newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex],
      key: "firstLevel",
      value: e?.target?.value,
      secondLevel: newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
        ?.secondLevel
        ? newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
            ?.secondLevel
        : [],
    };
    setData([...newData]);
  };

  const handleSubDelete = (index: number, subIndex: number) => {
    
    let newData = JSON.parse(JSON.stringify(data));
    if(type==="Edit"){
      newData[index].subHeading[subIndex].is_deleted=true
      handleDeleteRecursive(newData[index]?.subHeading[subIndex]?.firstLevel)
    }else{
      newData[index]?.subHeading?.splice(subIndex, 1);
    }
   
    setData([...newData]);
  };

  const handleDeleteRecursive=(data:any)=>{
   if (data?.length > 0) {
    for (const item of data) {
      item.is_deleted=true
      if (item?.subHeading) {
        handleDeleteRecursive(item?.subHeading)
      }
      if (item?.firstLevel) {
        handleDeleteRecursive(item?.firstLevel)
      }
      if (item?.secondLevel) {
        handleDeleteRecursive(item?.secondLevel)
      }
    }
  }
  }

  const handleFirstLevelDelete = (
    index: number,
    subIndex: number,
    firstIndex: number
  ) => {
    let newData = JSON.parse(JSON.stringify(data));
    if(type==="Edit"){
      newData[index].subHeading[subIndex].firstLevel[firstIndex].is_deleted=true 
      handleDeleteRecursive(newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]?.secondLevel)
    }else{
      newData[index]?.subHeading[subIndex]?.firstLevel?.splice(firstIndex, 1);
    }
    
    setData([...newData]);
  };

  const handleSecondLevelDelete = (
    index: number,
    subIndex: number,
    firstIndex: number,
    secondIndex: number
  ) => {
    let newData = JSON.parse(JSON.stringify(data));
    if(type==="Edit"){
      newData[index].subHeading[subIndex].firstLevel[firstIndex].secondLevel[
        secondIndex
      ] = {
        ...newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
          ?.secondLevel[secondIndex],
          is_deleted:true
      };
    }else{
      newData[index]?.subHeading[subIndex]?.firstLevel[
        firstIndex
      ]?.secondLevel?.splice(secondIndex, 1);
    }
  
    setData([...newData]);
  };

  const handleSecondLevelChange = (
    e: any,
    index: number,
    subIndex: number,
    firstIndex: number,
    secondIndex: number
  ) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData[index].subHeading[subIndex].firstLevel[firstIndex].secondLevel[
      secondIndex
    ] = {
      ...newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
        ?.secondLevel[secondIndex],
      key: "secondLevel",
      value: e?.target?.value,
      thirdLevel: newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
        ?.secondLevel
        ? newData[index]?.subHeading[subIndex]?.firstLevel[firstIndex]
            ?.secondLevel[secondIndex]?.thirdLevel
        : [],
    };
    setData([...newData]);
  };

  const handleProcedureDelete = (key: number) => {
    let newData = JSON.parse(JSON.stringify(data));
    if(type==="Edit"){
      newData[key].is_deleted=true
      handleDeleteRecursive(newData[key]?.subHeading)
    }else{
      newData?.splice(key, 1);
    }
   
    setData([...newData]);
  };

  return (
    <div className="newJobBox p-3" style={{ width: "70%" }}>
      <div>
        <div className="subTitle mb-2">
          {type} Checklist Title <span className="color-red">*</span>
        </div>

        <div className="d-flex" style={{ gap: "5px" }}>
          <div className="input-block mb-4" style={{ width: "55%" }}>
            <input
              type="text"
              value={title}
              style={{ border: "none" }}
              className="form-control"
              onChange={(e) => setTitle(e.target.value)}
            />{" "}
          </div>
          <div
            className="pointer addGuidlines"
            onClick={() => setModal((prev: boolean) => !prev)}
          >
            {" "}
            <img src={AddIconColor} alt="Add" /> {`${type} Guidelines`}
          </div>
        </div>

        {/* Procedure  */}
        <div className="pl-4 pb-4 pt-4">
          <div className="mt-2 mb-2 add_checklist_item">
            {type} Checklist Item Below
          </div>
          {data?.map((item: ProcedureType, index: number) => {
            if(!item?.is_deleted){
              return (
                <div className="mb-2 mt-2" style={{ paddingRight: "30px" }} key={index}>
                  <div
                    className="d-flex align-items-center justify-center outer-input mb-2"
                    style={{ paddingRight: "30px" }}
                  >
                    <div className="d-flex align-items-center justify-center input-block">
                      <div className="pl-2">
                        <AddParentChildBtn
                          type="procedure"
                          addParent={handleAddProcedure}
                          addChild={handleAddSubHeading}
                          index={index}
                        />
                        {/* </div> */}
                      </div>
                      <textarea
                        style={{ border: "none", resize: "none" }}
                        className="form-control"
                        value={item?.value}
                        onChange={(e) => handleChange(e, index)}
                      />{" "}
                    </div>
                    {index > 0 ? (
                      <div
                        className="pointer pr-2 pl-1"
                        onClick={() => handleProcedureDelete(index)}
                      >
                        <img src={RedDeleteIcon} alt="delete" />
                      </div>
                    ) : (
                      <div style={{ width: "20px" }}></div>
                    )}
                  </div>
  
                  {/* subHeading  */}
                  <div
                    className="ml-5"
                    style={{
                      border:
                       ( item?.subHeading?.length > 0 && item?.subHeading?.find((item:SubHeadingType)=>!item?.is_deleted)) ? "1px solid #bfcbe1" : "",
                    }}
                  >
                    {item?.subHeading?.map(
                      (sub: SubHeadingType, subIndex: number) => {
                        if(!sub?.is_deleted){
                          return (
                            <div className="subheading" key={index?.toString()+subIndex?.toString()}>
                              <div className="d-flex align-items-center justify-center outer-input">
                                <div
                                  className={`d-flex align-items-center justify-center ${
                                    item?.value ? "input-block" : "disabled-block"
                                  }`}
                                >
                                  <div className="pl-2">
                                    <AddParentChildBtn
                                      type="subheading"
                                      addParent={handleAddSubHeading}
                                      addChild={handleAddFirstLevel}
                                      index={index}
                                      subIndex={subIndex}
                                      disabled={!item?.value}
                                    />
                                  </div>
                                  <textarea
                                    style={{ border: "none", resize: "none" }}
                                    className="form-control"
                                    disabled={!item?.value}
                                    value={sub?.value}
                                    onChange={(e) =>
                                      handleSubChange(e, index, subIndex)
                                    }
                                  />{" "}
                                </div>
                                <div
                                  className="pointer pr-2 pl-1"
                                  onClick={() => handleSubDelete(index, subIndex)}
                                >
                                  <img src={RedDeleteIcon} alt="delete" />
                                </div>{" "}
                              </div>
    
                              {/* first Level  */}
                              <div className="pl-5 pt-3 aboveFirstLevel">
                                {/* <div>First Level</div> */}
                                {sub?.firstLevel?.map(
                                  (first: FirstLevelType, firstIndex: number) => {
                                    if(!first?.is_deleted){
                                    return (
                                      <div className="pt-3 firstLevel" key={index?.toString() + subIndex?.toString() + firstIndex?.toString()}>
                                        <div className="d-flex align-items-center justify-center outer-input">
                                          <div
                                            className={`d-flex align-items-center justify-center ${
                                              sub?.value
                                                ? "input-block"
                                                : "disabled-block"
                                            }`}
                                          >
                                            <div className="pl-2">
                                              <AddParentChildBtn
                                                type="firstLevel"
                                                addParent={handleAddFirstLevel}
                                                addChild={handleAddSecondLevel}
                                                index={index}
                                                subIndex={subIndex}
                                                firstIndex={firstIndex}
                                                disabled={!sub?.value}
                                              />
                                              {/* </div> */}
                                            </div>
                                            <textarea
                                              className="form-control"
                                              disabled={!sub.value}
                                              style={{
                                                border: "none",
                                                resize: "none",
                                              }}
                                              value={first?.value}
                                              onChange={(e) =>
                                                handleFirstLevelChange(
                                                  e,
                                                  index,
                                                  subIndex,
                                                  firstIndex
                                                )
                                              }
                                            />{" "}
                                          </div>
                                          <div
                                            className="pointer pr-2 pl-1"
                                            onClick={() =>
                                              handleFirstLevelDelete(
                                                index,
                                                subIndex,
                                                firstIndex
                                              )
                                            }
                                          >
                                            <img src={RedDeleteIcon} alt="delete" />
                                          </div>{" "}
                                        </div>
                                        {/* second level  */}
                                        <div
                                          className={`pl-5 aboveSecondLevel ${
                                            first?.secondLevel?.length > 0
                                              ? "pt-3"
                                              : ""
                                          }`}
                                          style={{ marginRight: "-3px" }}
                                        >
                                          {/* <div>Second Level</div> */}
                                          {first?.secondLevel?.map(
                                            (
                                              second: SecondLevelType,
                                              secondIndex: number
                                            ) => {
                                              if(!second?.is_deleted){
                                              return (
                                                <div className="secondLevel" key={index?.toString() + subIndex?.toString() + firstIndex?.toString() + secondIndex?.toString()}>
                                                  <div className="d-flex align-items-center justify-center outer-input">
                                                    <div
                                                      className={`d-flex align-items-center justify-center ${
                                                        first?.value
                                                          ? "input-block"
                                                          : "disabled-block"
                                                      }`}
                                                    >
                                                      <div className="pl-2">
                                                        <AddParentChildBtn
                                                          type="secondLevel"
                                                          addParent={
                                                            handleAddSecondLevel
                                                          }
                                                          addChild={
                                                            handleAddSecondLevel
                                                          }
                                                          index={index}
                                                          subIndex={subIndex}
                                                          firstIndex={firstIndex}
                                                          secondIndex={secondIndex}
                                                          disabled={!first?.value}
                                                        />
                                                      </div>
                                                      <textarea
                                                        className="form-control"
                                                        style={{
                                                          border: "none",
                                                          resize: "none",
                                                        }}
                                                        value={second?.value}
                                                        disabled={!first?.value}
                                                        onChange={(e) =>
                                                          handleSecondLevelChange(
                                                            e,
                                                            index,
                                                            subIndex,
                                                            firstIndex,
                                                            secondIndex
                                                          )
                                                        }
                                                      />{" "}
                                                    </div>
                                                    <div
                                                      className="pointer pr-2 pl-1"
                                                      onClick={() =>
                                                        handleSecondLevelDelete(
                                                          index,
                                                          subIndex,
                                                          firstIndex,
                                                          secondIndex
                                                        )
                                                      }
                                                    >
                                                      <img
                                                        src={RedDeleteIcon}
                                                        alt="delete"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              );}
                                            }
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                  }
                                )}
                              </div>
                            </div>
                          );
                        }
                        
                      }
                    )}
                  </div>
                </div>
              );
            }
           
          })}
        </div>
      </div>
      {/* cancel/submit button  */}

      <div style={{ alignItems: "flex-end" }}>
        <div style={{ marginTop: "2rem" }}>
          <hr></hr>
        </div>

        <div className="row mt-3">
          <div className="col-md-12 d-flex justify-content-end ">
            <button
              className="btn ml-3"
              style={{ border: "1px solid #bfcbe1" }}
              onClick={() => handleGoBack()}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary ml-3 pr-4 pl-4"
              disabled={!title}
              onClick={() => handleSubmit()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMoreInput;
